<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Company information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="General"></el-step>
                  <el-step title="Representives"></el-step>
                  <el-step title="Beneficial Owners"></el-step>
                  <el-step title="Documentation"></el-step>
                  <el-step title="Banking Info"></el-step>
                  <el-step title="Questionnaire"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-10 col-lg-10"
              style="margin-left: 10%; margin-top: 40px"
            >
              <!-- <el-page-header content="Authentication"> </el-page-header> -->
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-row>
                  <el-col :span="12">
                    <el-row>
                      <el-col :span="22">
                        <el-form-item prop="s2_is_s3">
                          <span slot="label"
                            >Whether you are a corporate legal entity or
                            not</span
                          >

                          <el-radio-group
                            v-model="formData.s2_is_s3"
                            size="medium"
                          >
                            <el-radio
                              v-for="(item, index) in yesOrNoOptions()"
                              :key="index"
                              :label="item.value"
                              :disabled="item.disabled"
                              >{{ item.label }}</el-radio
                            >
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-row>
                      <el-col :span="22">
                        <el-form-item prop="s2_email">
                          <span slot="label">Email</span>
                          <el-input
                            v-model="formData.s2_email"
                            placeholder="Please enter your email"
                            clearable
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12">
                    <el-row>
                      <el-col :span="22">
                        <el-form-item
                          label="Telephone number"
                          prop="s2_telephone"
                        >
                          <el-input
                            v-model="formData.s2_telephone"
                            placeholder="Please enter your telephone number"
                            clearable
                            :style="{ width: '100%' }"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="21">
                            <el-form-item
                              label="First name"
                              prop="s2_first_name"
                            >
                              <el-input
                                v-model="formData.s2_first_name"
                                placeholder="First name"
                                clearable
                                :style="{ width: '100%' }"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="20">
                            <el-form-item
                              label="Middle Name(Optional)"
                              prop="middlename"
                            >
                              <el-input
                                v-model="formData.s2_middle_name"
                                placeholder="Middle Name(Optional)"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="20">
                            <el-form-item label="Last name" prop="s2_last_name">
                              <el-input
                                v-model="formData.s2_last_name"
                                placeholder="Last name"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="20">
                            <el-form-item label="Title" prop="s2_title">
                              <el-input
                                v-model="formData.s2_title"
                                placeholder="e.g. CEO"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="6">
                    <el-col :span="22">
                      <el-form-item label="Country" prop="s2_country">
                        <el-select
                          filterable
                          v-model="formData.s2_country"
                          placeholder="Please select a country"
                          clearable
                          :style="{ width: '100%' }"
                        >
                          <el-option
                            v-for="(item, index) in countryOptions()"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col :span="6">
                    <el-col :span="22">
                      <el-form-item label="State / Province" prop="s2_province">
                        <el-input
                          v-model="formData.s2_province"
                          placeholder="Please enter the state.or province"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col :span="6">
                    <el-col :span="22">
                      <el-form-item label="City" prop="s2_city">
                        <el-input
                          v-model="formData.s2_city"
                          placeholder="Please enter the city"
                          clearable
                          :style="{ width: '100%' }"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col :span="6">
                    <el-col :span="20">
                      <el-form-item label="Zip Code" prop="s2_zip_code">
                        <el-input
                          v-model="formData.s2_zip_code"
                          placeholder="Please enter the zip code"
                          clearable
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col :span="22">
                    <el-form-item label="Residential Address" prop="s2_address">
                      <el-input
                        v-model="formData.s2_address"
                        placeholder="Residential address"
                        clearable
                        :style="{ width: '100%' }"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item
                              label="Date of Birth"
                              prop="s2_birthday"
                            >
                              <el-date-picker
                                v-model="formData.s2_birthday"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :style="{ width: '100%' }"
                                placeholder="Please choose a birthday"
                                clearable
                              ></el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>

                <el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        label="Passport number (or U.S. driver's license number)"
                        prop="s2_id_no"
                      >
                        <el-input
                          v-model="formData.s2_id_no"
                          placeholder="Passport number (or U.S. driver's license number)"
                          clearable
                          :style="{ width: '70%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item
                        label="Identification documents"
                        prop="s2_id_type"
                      >
                        <el-radio-group
                          v-model="formData.s2_id_type"
                          size="medium"
                        >
                          <el-radio
                            v-for="(item, index) in idfileTypeOptions"
                            :key="index"
                            :label="item.value"
                            :disabled="item.disabled"
                            >{{ item.label }}</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="International passport/US driver's license"
                        label-width="0"
                        prop="s2_id_file"
                        required
                      >
                        <FileUpload
                          emitaction="setidfileurl"
                          :fileurl="formData.s2_id_file"
                          v-on:emitaction="setidfileurl"
                        ></FileUpload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="Selfie"
                        prop="s2_selfie_file"
                        required
                      >
                        <FileUpload
                          emitaction="setselfiefile"
                          :fileurl="formData.s2_selfie_file"
                          v-on:emitaction="setselfiefileurl"
                        ></FileUpload>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-row>

                <el-row>
                  <el-col>
                    <el-form-item
                      label="Tip: Make sure your photo meets the following requirements! Otherwise you may not pass the verification"
                    >
                      <p>i, International passport/US driver's license</p>
                      <p>
                        1, Photo must be less than 3.6MB, &lt; 3200px * 4000px
                      </p>
                      <p>
                        2, The photo must be larger than 500KB, > 800px * 1000px
                      </p>
                      <p>
                        3, The format of the photo must be .jpg, .jpeg or
                        .png.(PDF format is not accepted)
                      </p>
                      <p>
                        4, The photo should be well lit and in focus（ Our
                        system cannot recognize blurry photos!）
                      </p>
                      <p>
                        5, Photos should cover the entire file and clearly show
                        the required information
                      </p>
                      <p>6, No filters, cropping, watermarks</p>
                      <p>7, Keep your head straight and no rotation</p>
                      <p>ii, Selfie</p>
                      <p>
                        A photo of yourself with the entire face clearly
                        visible. Take off any accessories such as glasses when
                        taking photos. The photo should be well lit and in
                        focus.
                      </p>
                      <p>iii, proof of residence</p>
                      <p>
                        Please upload utility bills, bank statements,
                        cable/internet bills that include your name and address.
                      </p>
                    </el-form-item>
                    <!-- <el-form-item label="提示：请注意文件需要满足以下要求，否则可能会导致身份验证失败！">
                      <p>一、护照/美国驾驶证： </p><p>1、图像文件尺寸小于 3.6 MB, 宽小于3200px * 高4000px </p>
                        <p>2、图像文件尺寸>500 KB, >宽1000px * 高1280px</p>
                      <p>3、文件格式必须是 .jpg 或 .jpeg. (不接受PDF格式)</p>
                      <p>4、照片必须彩色、清晰。</p>
                      <p>5、照片不可裁剪、加水印、滤镜、美化、PS</p>
                      <p>6、照片应包含完整的文档内容，并能清楚显示所需信息</p>
                      <p>7、人物头部竖直，不可旋转或水平 </p><p>二、自拍照</p>
                      <p>请上传正面自拍照。照片必须为彩色，清晰，背景为浅色。拍照时请不要佩带帽子、眼镜和首饰。</p>
                      <p>三、地址证明</p>
                      <p>请提供 3个月内银行对账单清晰扫描。扫描件必须明确包括申请人居住地址以及名称。</p>
                    </el-form-item> -->
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 40px">
                  <el-col :span="6" :offset="0"></el-col>
                  <el-col :span="10" :offset="10">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import FileUpload from "../../components/plugins/FileUpload2.vue";
import {
  otc_auth_status,
  get_info,
  att_info,
} from "../../plugins/api/account_otc";
import {
  countryOptions,
  yesOrNoOptions,
} from "../../plugins/data/form_base_data";
export default {
  components: { FileUpload },
  props: [],
  data() {
    return {
      activeStep: 1,
      formData: {
        process: 2,
      },
      rules: {
        s2_email: [
          {
            required: true,
            message: "please enter email",
            trigger: "blur",
          },
        ],
        s2_first_name: [
          {
            required: true,
            message: "please enter first name",
            trigger: "blur",
          },
        ],
        s2_last_name: [
          {
            required: true,
            message: "please enter last name",
            trigger: "blur",
          },
        ],
        s2_telephone: [
          {
            required: true,
            message: "please enter telephone number",
            trigger: "blur",
          },
        ],
        s2_province: [
          {
            required: true,
            message: "please enter state / province",
            trigger: "blur",
          },
        ],
        s2_country: [
          {
            required: true,
            message: "please enter country",
            trigger: "blur",
          },
        ],
        s2_city: [
          {
            required: true,
            message: "please enter city",
            trigger: "blur",
          },
        ],
        s2_zip_code: [
          {
            required: true,
            message: "please enter zip code",
            trigger: "blur",
          },
        ],
        s2_address: [
          {
            required: true,
            message: "please enter address",
            trigger: "blur",
          },
        ],
        s2_birthday: [
          {
            required: true,
            message: "please select birthday",
            trigger: "blur",
          },
        ],
        s2_title: [
          {
            required: true,
            message: "please select title",
            trigger: "blur",
          },
        ],
        s2_id_no: [
          {
            required: true,
            message: "Passport number (or U.S. driver's license number)",
            trigger: "blur",
          },
        ],
        s2_id_type: [
          {
            required: true,
            message: "please chose id type",
            trigger: "change",
          },
        ],
        s2_id_file: [
          {
            required: true,
            message: "please chose passport/US driver's license picture",
            trigger: "change",
          },
        ],
        s2_selfie_file: [
          {
            required: true,
            message: "please chose selfie picture",
            trigger: "change",
          },
        ],
      },
      idFileAction: "",
      idFilefileList: [],
      selfieAction: "",
      selfiefileList: [],
      addrProveAction: "",
      addrProvefileList: [],
      idfileTypeOptions: [
        {
          label: "Passport",
          value: 1,
        },
        {
          label: "U.S. driver's license",
          value: 2,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_info(
      `/account_otc/get_company_info?process=${this.formData.process}`
    ).then((res_query) => {
      if (res_query.data) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
        this.formData.s2_is_s3 = `${this.formData.s2_is_s3}`;
      } else {
      }
    });
  },
  mounted() {},
  methods: {
    yesOrNoOptions() {
      return yesOrNoOptions;
    },
    countryOptions() {
      return countryOptions;
    },
    setidfileurl(url) {
      this.formData.s2_id_file = url;
    },
    setselfiefileurl(url) {
      this.formData.s2_selfie_file = url;
    },
    setprovefileurl(url) {
      this.formData.s2_province = url;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        this.formData.process = 2;
        att_info("/account_otc/att_company_info", this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/inc_cert/step3");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    idFileBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    selfieBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    addrProveBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    goback() {
      this.$router.push("/reg/inc_cert/step1");
    },
  },
};
</script>
<style>
.el-icon-plus:before {
  top: 70px;
  position: relative;
}
.el-upload__tip {
  line-height: 1.2;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>